<template>
    <v-card style="height: 100%" class="course-card bordered pa-2">
        <div :style="`background-image: url(${course.image_url}); height: ${phoneOnly ? 200 : (short ? 150 : 170)}px; background-size: cover; background-position: center; width: 100%`" @click="$router.push({name: 'course', params: {id: course.id}})" v-ripple class="e-link">
            <div class="pa-3 d-flex justify-space-between">
                <div>
                    <v-chip v-if="course.lectures_count" color="white" small @click.stop @touchstart.stop>
                        <v-icon color="muted" small class="me-1">mdi-play-circle-outline</v-icon>
                        {{unitFormat(course.lectures_count, 'محاضرة', 'محاضرتين', 'محاضرات')}}
                    </v-chip>
                </div>
                <div>
                    <v-chip v-if="course.featured" small dark color="orange darken-1" @click.stop @touchstart.stop>
                        <v-icon size="15" class="me-1">mdi-star</v-icon>
                        مميز
                    </v-chip>
                </div>
            </div>
        </div>
        <v-card-title as="router-link" class="course-title mb-1 px-5" :class="{'sm-title': short}">
            <router-link class="strong-text--text" style="text-decoration: none" :to="{name: 'course', params: {id: course.id}}">
                {{course.name}}
            </router-link>
        </v-card-title>
        <v-card-subtitle class="d-flex align-center px-5">
            <div class="me-2">
                <v-chip label small class="blue-grey--text text--darken-3 blue-grey lighten-5 pe-2 ps-2" style="height: 20px">
                    <v-icon size="14" color="blue-grey darken-2">mdi-account-group</v-icon>
                    <span class="ms-1">{{unitFormat(course.users_count, 'طالب', 'طالبين', 'طلاب')}}</span>
                </v-chip>
            </div>
            <div>{{gradesComputed}}</div>
        </v-card-subtitle>
        <v-card-text v-if="!short" class="pt-0 px-5">
            <div class="categories mb-4">
                <v-chip v-for="category in course.categories" color="primary" outlined :key="category.id" label small class="me-2">{{category.name}}</v-chip>
            </div>
            <div v-if="course.teachers && course.teachers.length" class="teachers-wrapper d-flex align-center">
                <v-chip v-for="teacher in course.teachers" small :key="'teacher-' + teacher.id" color="grey lighten-4" class="font-weight-medium px-1 pe-3 me-2">
                    <v-avatar class="me-2" style="min-width: 20px!important; width: 20px!important; height: 20px!important;">
                        <v-img :src="teacher.avatar"></v-img>
                    </v-avatar>
                    <span>{{teacher.name}}</span>
                </v-chip>
            </div>
        </v-card-text>
    </v-card>
</template>

<script>

import GlobalComputed from '@/helpers/global-computed'
import GlobalMethods from '@/helpers/global-methods'

export default {
    props: {
        course: {},
        short: {type: Boolean, default: false}
    },
    components: {},
    data(){
        return {
            
        }
    },
    computed: {
        gradesComputed(){
            const grades = this.course.grades;
            let text = '';
            grades.forEach((grade, i)=>{
                text += grade.name;
                if (i !== grades.length-1){
                    text += '، ';
                }
            })
            return text;
        },
        categoriesComputed(){
            const categories = this.course.categories;
            let text = '';
            categories.forEach((category, i)=>{
                text += category.name;
                if (i !== categories.length-1){
                    text += '، ';
                }
            })
            return text;
        },
        ...GlobalComputed
    },
    methods: {
        ...GlobalMethods
    }
}
</script>

<style lang="scss" scoped>
.course-card.v-card{
    transition: 0.1s ease all;
    border-radius: 6px!important;
    overflow: hidden;
    // box-shadow: 1px 2px 4px rgba(0,0,0, .1)!important;
    &:hover{
        // box-shadow: 1px 3px 9px 2px rgba(0,0,0, .1)!important;
    }

    .course-title {
        line-height: 1.4;
        font-size: 1.15rem;
        &.sm-title{
            font-size: 1.08rem;

        }

        a{
            text-decoration: none;
            word-break: normal;
            white-space: nowrap;
            text-overflow: ellipsis!important;
            overflow: hidden!important;
        }
    }
}
</style>